import React, { FunctionComponent, ComponentProps, useCallback, MouseEventHandler, useRef } from 'react';
import { FixedContentPortal } from '../../fixedContent/FixedContentPortal/FixedContentPortal';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ModalWithBackdrop.module.css';
export type ModalWithBackdropProps = ComponentProps<'div'> & {
  opened: boolean;
  onBackdropClick?: () => void;
};

/**
 * Keep in mind that the children will be placed in a flex layout
 */
export const ModalWithBackdrop: FunctionComponent<ModalWithBackdropProps> = React.memo(props => {
  const {
    opened,
    onBackdropClick,
    className,
    children,
    ...remainingProps
  } = prepareProps({
    props
  });
  const modalElementRef = useRef<HTMLDivElement | null>(null);
  const clickStartedInContentRef = useRef<boolean>(false);
  const handleModalClick: MouseEventHandler<HTMLDivElement> = useCallback(event => {
    if (event.target === modalElementRef.current && !clickStartedInContentRef.current) {
      onBackdropClick?.();
    }
    clickStartedInContentRef.current = false;
  }, [modalElementRef, clickStartedInContentRef, onBackdropClick]);
  const handleModalMouseDown: MouseEventHandler<HTMLDivElement> = useCallback(event_0 => {
    clickStartedInContentRef.current = event_0.target !== modalElementRef.current;
  }, [modalElementRef, clickStartedInContentRef]);
  if (!opened) {
    return null;
  }
  return <FixedContentPortal>
        <div data-testid="modal" {...remainingProps} ref={modalElementRef} className={classes(className, styles.modal)} onMouseDown={handleModalMouseDown} onClick={handleModalClick}>
          {children}
        </div>
      </FixedContentPortal>;
});